import { render, staticRenderFns } from "./biographie.vue?vue&type=template&id=0dde6046&scoped=true&"
import script from "./biographie.vue?vue&type=script&lang=js&"
export * from "./biographie.vue?vue&type=script&lang=js&"
import style0 from "./biographie.vue?vue&type=style&index=0&id=0dde6046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde6046",
  null
  
)

export default component.exports